export const GET_ONFIDO_CHECK_LIST_REQUEST = 'GET_ONFIDO_CHECK_LIST_REQUEST';
export const GET_ONFIDO_CHECK_LIST_SUCCESS = 'GET_ONFIDO_CHECK_LIST_SUCCESS';
export const GET_ONFIDO_CHECK_LIST_ERROR = 'GET_ONFIDO_CHECK_LIST_ERROR';

